/**
 * @todo deprecated render={({
 * @todo buttons
 * @todo redirect after sign in
 */
import * as React from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import TagManager from 'react-gtm-module';

import { useFeedbackFormContext } from './FeedbackFormContext';
import { FormWrapper, CloseIcon, DisplayedAfterVoting } from './Form.styled';
// import messages from './messages';
// import { usePruslation } from '../../utils/hooks';
// import { useLocalStorage } from '../../utils/hooks';
import { useAuthContext } from '../../AuthProvider/context';
import IntlText from '../IntlText';
import messages from '../messages';
import SecondStep from '../SecondStep/SecondStep';
import Thumbs from '../Thumbs/Thumbs';
import { PostType } from '../types';

const LogInMessage = () => {
  const translate = useTranslations();
  const pathname = usePathname();

  return (
    <>
      {translate.rich(messages.notice, {
        link: chunks => (
          <>
            <Link href={`${process.env.NEXT_PUBLIC_LOGIN_URL}?redirect=${pathname}`}>{chunks}</Link>
          </>
        ),
      })}
    </>
  );
};

// { entityType = 'page' }
/**
 * @todo translate
 */
export default function Form({ entityType = 'page' }: { entityType: PostType }) {
  const { isUserLoggedIn } = useAuthContext();
  const { thumbState, isUnfolded, closeAction, isSent } = useFeedbackFormContext();

  // const { t } = usePruslation();
  // const locale = useLocale();
  // const [, setLoc] = useLocalStorage('pkb_redirect_url', null);

  const keydownListener = React.useCallback(event => {
    if (event.key === 'Escape') closeAction();
  }, []);

  React.useEffect(() => {
    if (process.browser) {
      document.addEventListener('keydown', keydownListener);

      return () => {
        document.removeEventListener('keydown', keydownListener);
      };
    }
  }, []);

  React.useEffect(() => {
    if (thumbState) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'feedback',
          vote: thumbState,
        },
      });
    }
  }, [thumbState]);

  return (
    <FormWrapper $unfolded={!!thumbState && isUnfolded}>
      {!isSent && <CloseIcon name="xmark" size="lg" onClick={closeAction} />}
      <IntlText index={messages[entityType]} />
      <Thumbs />
      <DisplayedAfterVoting>{!isUserLoggedIn ? <LogInMessage /> : <SecondStep />}</DisplayedAfterVoting>
    </FormWrapper>
  );
}
